import React from "react";

class Card extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { customClasses } = this.props;

        return (
            <React.Fragment>
                <div className={`apps-card-container ${customClasses ? customClasses : "" }`} data-testid='card-container'>
                    {this.props.children}
                </div>
            </React.Fragment>
        );
    }
}

export default Card;